/**
 * Shared checks for medical_order_status values that should block order detail.
 *
 * @module isInvalidMedicalOrderStatus
 */

import { MedicalOrderStatus } from "../enums/orderReviewStatus";

/**
 * Returns true when medical_order_status is missing or blank.
 *
 * @param status - Raw medical_order_status from an order or worklist hit
 * @returns True for null, undefined, or empty/whitespace strings
 */
export const isInvalidMedicalOrderStatus = (
  status: string | null | undefined,
): boolean => status == null || status.trim() === "";

/**
 * Returns true when the order should be blocked from opening.
 *
 * @param status - Raw medical_order_status from an order or worklist hit
 * @returns True when status is invalid or agent-in-progress
 */
export const isBlockedMedicalOrderStatus = (
  status: string | null | undefined,
): boolean =>
  isInvalidMedicalOrderStatus(status) ||
  status === MedicalOrderStatus.AGENT_IN_PROGRESS;
